import React from 'react'
import { NavLink } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const MenuItem = ({ active, icon, path, text, onClick }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(path);
    if (onClick) onClick();
  };

  return (
    <NavLink
      onClick={ handleNavigate }
      variant="light"
      color="yellow"
      active={ active }
      label={ text }
      leftSection={ icon }
      styles={{
        root: {
          borderRadius: '4px',
          fontWeight: active ? 800 : 500,
          borderLeft: active ? '3px solid var(--mantine-color-yellow-filled)' : '3px solid transparent',
          backgroundColor: active ? 'var(--mantine-color-yellow-light)' : 'transparent',
          transition: 'all 0.2s ease',
        },
        label: {
          fontSize: 'var(--mantine-font-size-sm)',
          letterSpacing: '0.2px',
          textTransform: 'uppercase',
        }
      }}
    />
  )
}

export default MenuItem
